module.exports = __webpack_public_path__ + "img/117.936ddbd6.jpg";